// src/services/settingsService.js
import axios from "../config/axiosConfig";

export const getSetting = (clave) => axios.get(`/api/settings/${encodeURIComponent(clave)}`);

export const setSetting = (clave, valor) =>
  axios.put(`/api/settings/${encodeURIComponent(clave)}`, { valor });
